import { makeParams } from "../utilities/utilities";
import Axios from "./Axios";
import API_URL from "./URLS";

export const REGISTER = (data) => Axios.post(API_URL.REGISTER_URL, data);
export const LOGIN_ADMIN = (data) => Axios.post(API_URL.LOGIN_ADMIN, data);
export const LOGOUT_ADMIN = (data) => Axios.post(API_URL.LOGOUT_ADMIN, data);
export const FORGET_PASSWORD_ADMIN = (data) =>
  Axios.post(API_URL.FORGET_PASSWORD_ADMIN, data);
export const RESET_PASSWORD = (data) =>
  Axios.post(API_URL.RESET_PASSWORD, data);
export const CHANGE_PASSWORD = (data) =>
  Axios.post(API_URL.CHANGE_PASSWORD, data);
export const GET_PROFILE = (data) => Axios.get(API_URL.GET_PROFILE);
export const GET_REVIEWS = (data) => Axios.get(API_URL.GET_GUEST_REVIEWS);
export const UPDATE_PROFILE = (data) =>
  Axios.post(API_URL.UPDATE_PROFILE, data);
export const GET_USER_PERMISSIONS = () => Axios.get(API_URL.GET_USER_PERMISSIONS);
// upload file
export const UPLOAD_FILE = (data) => Axios.post(API_URL.UPLOAD_FILE, data);
export const UPLOAD_FILE_MULTIPLE = (data) => Axios.post(API_URL.UPLOAD_MULTIPLE_FILE, data);

// dashboard

export const NOTIFICATION_DATA = (data) => Axios.post(API_URL.NOTIFICATION, data);
export const READ_NOTIFICATION = (data) => Axios.post(API_URL.READ_NOTIFICATION, data);
export const NOTIFICATION_COUNT = (data) => Axios.get(API_URL.NOTIFICATION_COUNT,{});
export const DASHBOARD_DATA = (data) => Axios.get(API_URL.DASHBOARD_DATA, { params: data });
export const BOOKING_STATS_DATA = (data) => Axios.get(API_URL.GET_BOOKING_STATS, { params: data });
export const BOOKING_HISTORY_DATA = (data) => Axios.post(API_URL.BOOKING_HISTORY, data );
export const GET_PIE_CHART=(data)=> Axios.post(API_URL.PIE_CHART,data)
export const GET_HOTELS_LIST_FOR_FULL_PANEL_HANDLE_API = (data) => Axios.get(API_URL.GET_HOTELS_LIST_FOR_FULL_PANEL_HANDLE, { params: data });

// help

export const HELP_LIST = (data) => Axios.post(API_URL.HELP_LIST, data);

// accounting

export const ACCOUNTING_LIST = (data) => Axios.post(API_URL.ACCOUNTING_LIST);

// user
export const ADD_USER = (data) => Axios.post(API_URL.ADD_USER, data);
export const USER_LIST = (data) => Axios.post(API_URL.USER_LIST, data);
export const GET_USER_BY_ID = (data) =>
  Axios.get(API_URL.GET_USER_BY_ID + data);
export const UPDATE_USER = (data) => Axios.post(API_URL.UPDATE_USER, data);
export const DELETE_USER = (data) => Axios.post(API_URL.DELETE_USER, data);
export const DELETE_INQUIRY = (data) =>
  Axios.post(API_URL.DELETE_INQUIRY, data);

export const USER_STATUS_CHANGE = (data) =>
  Axios.post(API_URL.USER_STATUS_CHANGE, data);
export const USER_IMPORT_BY_CSV = (data) =>
  Axios.post(API_URL.IMPORT_HOTEL, data);
export const ARTIST_IMPORT_BY_CSV = (data) =>
  Axios.post(API_URL.ARTIST_IMPORT_BY_CSV, data);

// pricing delete api
export const DELETEPRICE = (data) => Axios.post(API_URL.PRICING_DELETE, data);

export const EXPORT_USER_CSV = (data) =>
  // Axios.get(API_URL.EXPORT_USER_CSV + data);
  Axios.post(API_URL.EXPORT_USER_CSV, data);
export const EXPORTBOOKING = (data) =>
  Axios.post(API_URL.EXPORT_BOOKING_CSV, data);
export const EXPORTACCOUNTING = (data) =>
  Axios.post(API_URL.EXPORT_ACCOUNTING_CSV, data);

// service provider
export const SERVICE_PROVIDERS_LIST = (data) =>
  Axios.post(`${API_URL.SERVICE_PROVIDERS_LIST}?type=${data.type}`, data);
export const SERVICE_PROVIDER_VIEW = (data) =>
  Axios.get(API_URL.SERVICE_PROVIDER_VIEW + data);
export const ADD_SERVICE_PROVIDER = (data) =>
  Axios.post(API_URL.ADD_SERVICE_PROVIDER, data);
export const DELETE_PROVIDER = (data) =>
  Axios.post(API_URL.DELETE_PROVIDER, data);
export const UPDATE_SERVICE_PROVIDER = (data) =>
  Axios.post(API_URL.UPDATE_SERVICE_PROVIDER, data);
export const STATUS_CHANGE_SERVICE_PROVIDER = (data) =>
  Axios.post(API_URL.STATUS_CHANGE_SERVICE_PROVIDER, data);
export const SERVICE_PROVIDER_IMPORT_BY_CSV = (data) =>
  Axios.post(API_URL.SERVICE_PROVIDER_IMPORT_BY_CSV, data);
export const EXPORT_SERVICE_PROVIDER_CSV = (data) =>
  Axios.post(API_URL.EXPORT_SERVICE_PROVIDER_CSV, data);
export const EXPORTHOTEL = (data) =>
  Axios.post(API_URL.EXPORT_HOTEL_LIST, data);
export const HOTELADMINBLOCKUNBLOC = (data) =>
  Axios.post(API_URL.HOTEL_ADMIN_BLOCK_UNBLOCK, data);

export const EXPORT_BOOKING_HISTORY_CSV_API = (data) =>
  Axios.post(API_URL.EXPORT_BOOKING_HISTORY_CSV, data);

export const EXPORT_BOOKING_CANCELLATION_CSV_API = (data) =>
  Axios.post(API_URL.EXPORT_BOOKING_CANCELLATION_CSV, data);


export const EXPORT_FINANCE_CSV_API = (data) =>
  Axios.post(API_URL.EXPORT_FINANCE_CSV, data);

// earning report
export const GET_EARNING_REPORT = (data) =>
  Axios.post(API_URL.GET_EARNING_REPORT, data);
// REVIEW MANAGEMENT
export const REVIEWSTATS = () => Axios.get(API_URL.REVIEW_STATS)
export const HIDEREVIEW = (data) => Axios.post(API_URL.HIDE_REVIEW,data)
export const REVIEWLIST = (data) => Axios.post(API_URL.REVIEW_LIST, data)
export const REVIEWREPLY = (data) => Axios.post(API_URL.REVIEW_REPLY, data)

// transaction
export const TRANSACTIONDETAIL = (data) => Axios.get(API_URL.TRANSACTION_DETAIL + data)
export const FINANCEOVERVIEWAPI = () => Axios.get(API_URL.FINANCE_OVERVIEW)
export const HANDLETRANCATIONAPI = (data) => Axios.post(API_URL.TRANSACTION, data)
export const SERVICE_CATEGORY_LIST = (data) =>
  Axios.post(API_URL.SERVICE_CATEGORY_LIST, data);
export const ADDSERVICECATEGORY = (data) =>
  Axios.post(API_URL.ADD_SERVICE_CATEGORY, data);
export const UPDATESERVICECATEGORY = (data) =>
  Axios.post(API_URL.UPDATE_SERVICE_CATEGORY, data);
export const DELETESERVICECATEGORY = (data) =>
  Axios.delete(API_URL.DELETE_SERVICE_CATEGORY + data?._id, data);
export const VIEWSERVICECATEGORY = (data) =>
  Axios.get(API_URL.VIEW_SERVICE_CATEGORY + data);

// Hotel Admin
export const HOTELADMIN = (data) => Axios.post(API_URL.HOTEL_ADMIN_LIST, data);
export const HOTELADMINADD = (data) =>
  Axios.post(API_URL.HOTEL_ADMIN_ADD, data);
export const HOTELADMINUPDATE = (data) =>
  Axios.post(API_URL.HOTEL_ADMIN_UPDATE, data);
export const HOTELADMINDELETE = (data) =>
  Axios.delete(API_URL.HOTEL_ADMIN_DELETE + data?._id);

// Hotel list
export const HOTELLIST = (data) => Axios.post(API_URL.HOTEL_LIST, data);
export const HOTELCREATE = (data) => Axios.post(API_URL.HOTEL_CREATE, data);
export const HOTELUPDATE = (data) => Axios.post(API_URL.HOTEL_UPDATE, data);
export const HOTELDELETE = (data) =>
  Axios.delete(API_URL.HOTEL_DELETE + data?._id);
export const HOTELDETAILS = (data) => Axios.get(API_URL.HOTEL_DETAIL + data);
// hotel-admin
export const AVAILABITYSTATUSHOTEL = (data) =>
  Axios.post(API_URL.CHANGE_AVAILABILITY_STATUS, data);
export const HOTELSTORESETTING = (data) =>
  Axios.get(API_URL.HOTEL_STORE_SETTING, data);

// Room Types------->
export const ROOMTYPE = (data) => Axios.post(API_URL.ROOM_TYPES, data);
export const ROOMTYPELIST = (data) => Axios.post(API_URL.ROOM_TYPES_LIST, data);
export const ROOMTYPEADD = (data) => Axios.post(API_URL.ROOM_TYPES_ADD, data);
export const ROOMTYPEUPDATE = (data) => Axios.post(API_URL.ROOM_TYPES_UPDATE, data);
export const CREATEROOMTYPE = (data) =>
  Axios.post(API_URL.CREATE_ROOM_TYPE, data);
export const ROOMTYPEDETAIL = (data) => Axios.get(API_URL.ROOM_GET_API + data);
export const ROOMTYPEDELETE = (data) =>
  Axios.delete(API_URL.ROMMTYPE_DELETE + data?._id);

// ROOMLIST
export const ROOMLIST = (data) => Axios.post(API_URL.ROOM_LIST, data);
export const ROOMADD = (data) => Axios.post(API_URL.ROOM_ADD, data);
export const AVAILROOM = (data) => Axios.post(API_URL.ROOM_AVAIL, data);
export const ROOMUPDATE = (data) => Axios.post(API_URL.ROOM_UPDATE, data);
export const ROOMDELETE = (data) =>
  Axios.delete(API_URL.ROOM_DELETE + data?._id);
// ROOM PRICING
export const ROOMPRICING = (data) => Axios.post(API_URL.ROOM_PRICING, data);
export const ROOMPRICINGLIST = (data) => Axios.post(API_URL.ROOM_PRICING_LIST, data);
export const ROOMPRICINGDETAIL = (data) => Axios.get(API_URL.ROOM_PRICING_DETAIL + data?.id);
export const ROOMPRICINGUPDATE = (data) => Axios.post(API_URL.ROOM_PRICING_UPDATE, data);
export const PRICINGSTATUSUPDATE = (data) => Axios.post(API_URL.PRICING_STATUS_UPDATE, data);

// help and support
export const HELPANDSUPPORTAPI = (data) =>
  Axios.post(API_URL.HELPANDSUPORT, data);
export const HELPANDSUPPORTDETAILS = (data) =>
  Axios.get(API_URL.SELPANDSUPPORTDETAIL + data);

// subscription ----->
export const SUBSCRIPTION_LIST = (data) =>
  Axios.post(API_URL.GET_SUBSCRIPTION, data);

export const SUBSCRIPTION_ADD = (data) =>
  Axios.post(API_URL.ADD_SUBSCRIPTION, data);
export const SUBSCRIPTION_EDIT = (data) =>
  Axios.post(API_URL.EDIT_SUBSCRIPTION, data);
export const SUBSCRIPTION_DELETE = (id) =>
  Axios.get(API_URL.DELETE_SUBSCRIPTION + id);
export const SUBSCRIPTION_DETAIL = (data) =>
  Axios.get(API_URL.VIEW_SUBSCRIPTION + data);
export const SUBSCRIPTION_SUBSCRIBER = (data) =>
  Axios.get(`${API_URL.GET_SUBSCRIPTION_SUBSCRIBER}${makeParams(data)}`);

// content
export const ADD_CONTENT = (data) => Axios.post(API_URL.ADD_CONTENT, data);
export const CONTENT_VIEW = (data) => Axios.get(API_URL.CONTENT_VIEW + data);
export const CONTENT_UPDATE = (data) =>
  Axios.post(API_URL.CONTENT_UPDATE, data);
export const CONTENT_STATUS_CHANGE = (data) =>
  Axios.post(API_URL.CONTENT_STATUS_CHANGE, data);
export const CONTENT_DELETE = (data) =>
  Axios.post(API_URL.CONTENT_DELETE, data);
export const CONTENT_LIST = (data) => Axios.post(API_URL.CONTENT_LIST, data);

// faq

export const ADD_FAQ = (data) => Axios.post(API_URL.ADD_FAQ, data);
export const FAQ_VIEW = (id) => Axios.get(API_URL.FAQ_VIEW + id);
export const UPDATE_FAQ = (data) => Axios.post(API_URL.FAQ_UPDATE, data);
export const CHANGE_FAQ_STATUS = (data) =>
  Axios.post(API_URL.FAQ_STATUS_CHANGE, data);
export const DELETE_FAQ = (id) => Axios.post(API_URL.FAQ_DELETE, id);
export const LIST_FAQS = (data) => Axios.post(API_URL.FAQ_LIST, data);

// Manage Promocode

export const ADD_PROMOCODE = (data) => Axios.post(API_URL.ADD_PROMOCODE, data);
export const UPDATE_PROMOCODE = (data) =>
  Axios.post(API_URL.UPDATE_PROMOCODE, data);
export const PROMOCODE_LIST = (data) =>
  Axios.post(API_URL.PROMOCODE_LIST, data);
export const DELETE_PROMOCODE = (data) =>
  Axios.delete(API_URL.DELETE_PROMOCODE + data._id);
export const GET_PROMOCODE_BY_ID = (data) =>
  Axios.get(API_URL.GET_PROMOCODE_BY_ID + data);
export const PROMOCODE_STATUS_CHANGE = (data) =>
  Axios.post(API_URL.PROMOCODE_STATUS_CHANGE, data);
export const GET_PROMOCODE_STATS_API = () =>
  Axios.get(API_URL.GET_PROMOCODE_STATS);



// Essential api
export const ESSENTAILLIST = (data) => Axios.post(API_URL.ESSENTAIL_LIST, data);
export const ESSENTAILADD = (data) => Axios.post(API_URL.ESSENTIAL_ADD, data);
export const ESSENTIALUPDATE = (data) =>
  Axios.put(API_URL.ESSENTIAL_UPDATE + data?._id, data);
export const ESSENTIALREMOVE = (data) =>
  Axios.delete(API_URL.ESSENTIAL_DELETE + data?._id);
export const ESSENTIALDETAIL = (data) =>
  Axios.get(API_URL.ESSENTIAL_DETAIL + data);
// Essential room  Api
export const ROOMESSENTAILLIST = (data) =>
  Axios.post(API_URL.ROOM_ESSENTIAL_LIST, data);
export const ROOMESSENTAILADD = (data) =>
  Axios.post(API_URL.ROOM_ESSENTIAL_ADD, data);
export const ROOMESSENTIALUPDATE = (data) =>
  Axios.put(API_URL.ROOM_ESSENTIAL_UPDATE + data?._id, data);
export const ROOMESSENTIALREMOVE = (data) =>
  Axios.delete(API_URL.ROOM_ESSENTIAL_DELETE + data?._id);
export const ROOMESSENTIALDETAIL = (data) =>
  Axios.get(API_URL.ROOM_ESSENTIAL_DETAIL + data);

export const ADD_SUB_ADMIN = (data) => Axios.post(API_URL.ADD_SUB_ADMIN, data);
export const UPDATE_SUB_ADMIN = (data) =>
  Axios.post(API_URL.UPDATE_SUB_ADMIN, data);
export const SUBADMINS_LIST = (data) =>
  Axios.post(API_URL.SUBADMINS_LIST, data);
export const DELETE_SUBADMIN = (data) =>
  Axios.post(API_URL.DELETE_SUBADMIN, data);
export const GET_SUBADMIN_BY_ID = (data) =>
  Axios.get(API_URL.GET_SUBADMIN_BY_ID + data);
export const UPDATE_SYSTEM_ACCESS_STATUS = (data) =>
  Axios.post(API_URL.UPDATE_SYSTEM_ACCESS_STATUS, data);

export const UPDATE_ROLE_STATUS = (data) =>
  Axios.post(API_URL.UPDATE_ROLE_STATUS, data);

//Role

export const ROLE_LIST = (data) => Axios.post(API_URL.GET_ROLES, data);
export const ROLE_ADD = (data) => Axios.post(API_URL.ADD_ROLES, data);
export const ROLE_EDIT = (data) => Axios.post(API_URL.EDIT_ROLE, data);
export const ROLE_DELETE = (id) => Axios.delete(API_URL.DELETE_ROLE + id);
export const ROLE_DETAIL = (data) => Axios.get(API_URL.VIEW_ROLE + data);

// Manage Commision
export const COMMISSIONS_LIST = (data) =>
  Axios.post(API_URL.COMMISSIONS_LIST, data);
export const DELETE_COMMISSION = (data) =>
  Axios.post(API_URL.DELETE_COMMISSION, data);
export const SET_COMMISSION = (data) =>
  Axios.post(API_URL.SET_COMMISSION, data);
// export const COMMISSIONS_LIST = () =>  Axios.post(API_URL.COMMISSIONS_LIST, data);
// export const DELETE_COMMISSION = () =>  Axios.post(API_URL.DELETE_COMMISSION, data);

// Order Management
export const GETBOOKING = (data) => Axios.post(API_URL.GET_BOOKING, data);
export const CANCELBOOKING = (data) => Axios.post(API_URL.CANCEL_BOOKING, data);
export const CANCELBOOKINGDETAIL = (data) => Axios.get(API_URL.CANCEL_BOOKING_DETAILS + data);
export const UPCOMMINGAPIDATA = (data) => Axios.post(API_URL.UPCOMMING_URL, data)
export const VIEW_BOOKING = (data) => Axios.get(API_URL.VIEW_BOOKING + data);
export const UPDATE_BOOKING = (data) => Axios.post(API_URL.UPDATE_BOOKING, data);
export const UPDATE_DISPUTE = (data) => Axios.post(API_URL.UPDATE_DISPUTE, data);
export const GET_BOOKING_STATS_API = (data) =>
  Axios.post(API_URL.GET_BOOKING_STATS,data);

export const GET_ALL_CONFIGS=()=>Axios.get(API_URL.CONFIGS);

// send reply
export const SENDREPLY = (data) => Axios.post(API_URL.SEND_REPLY, data);
// set pin api
export const SETPINAPI = (data) => Axios.post(API_URL.SET_PIN_URL, data);
export const PINLISTAPI = () => Axios.get(API_URL.PIN_LIST);

export const ADD_PROMOTION = (data) => Axios.post(API_URL.ADD_PROMOTION, data);
export const UPDATE_PROMOTION = (data) =>
  Axios.put(API_URL.UPDATE_PROMOTION + data?._id, data);
export const PROMOTION_LIST = (data) =>
  Axios.post(API_URL.PROMOTION_LIST, data);
export const DELETE_PROMOTION = (data) =>
  Axios.post(API_URL.DELETE_PROMOTION, data);
export const GET_PROMOTION_BY_ID = (data) =>
  Axios.get(API_URL.GET_PROMOTION_BY_ID + data);

export const BASIC_CONFIG_DATA = () => Axios.get(API_URL.CONFIG_DATA);
export const GET_BASIC_SETTING = () => Axios.get(API_URL.BASIC_SETTING);
export const UPDATE_BASIC_SETTING = (data) =>
  Axios.post(API_URL.UPDATE_BASIC_SETTING, data);

//Event
export const EVENT_LIST = (data) => Axios.post(API_URL.EVENT_LIST, data);
export const GET_JOB_BY_ID = (data) => Axios.get(API_URL.GET_JOB_BY_ID + data);
export const UPDATE_JOB = (data) => Axios.post(API_URL.UPDATE_JOB, data);
export const DELETE_JOB_POST = (data) =>
  Axios.post(API_URL.DELETE_JOB_POST, data);
// Hotel admin
export const ADDHOTElADMIN = (data) =>
  Axios.post(API_URL.ADD_HOTEL_ADMIN, data);

// Notifications List
export const GET_NOTIFICATION_LIST_API = (data) => Axios.post(API_URL.GET_NOTIFICATION_LIST, data);
export const MARK_ALL_NOTIFICATIONS_AS_READ_API = (data) => Axios.post(API_URL.MARK_ALL_NOTIFICATIONS_AS_READ, data);
export const MARK_NOTIFICATION_AS_READ_API = (id) =>
  Axios.post(API_URL.SINGLE_NOTIFICATION_MARK_AS_READ(id));

// Reports
export const CUSTOMER_REPORTS_API = (data) => Axios.post(API_URL.CUSTOMER_REPORTS, data);
export const REVENUE_REPORTS_API = (data) => Axios.post(API_URL.REVENUE_REPORTS, data);
export const GET_CUSTOMER_SEGMENTATION_DATA_API = (data) => Axios.post(API_URL.GET_CUSTOMER_SEGMENTATION_DATA, data);
export const GET_AGE_DISTRIBUTION_CHART_DATA_API = (data) => Axios.post(API_URL.GET_AGE_DISTRIBUTION_CHART_DATA, data);
export const GET_DURATION_TYPE_DISTRIBUTION_CHART_DATA_API = (data) => Axios.post(API_URL.GET_DURATION_TYPE_DISTRIBUTION_CHART_DATA, data);
export const GET_REVENUE_BY_ROOM_TYPE_CHART_DATA_API = (data) => Axios.post(API_URL.GET_REVENUE_BY_ROOM_TYPE_CHART_DATA, data);



